/** Shapes shared by the farm log screens. */

export interface LogSummary {
  slug: string;
  title: string;
  excerpt: string;
  published_at: string;
  entry_date: string | null;
  image: string | null;
  image_alt: string | null;
  image_content_type: string | null;
}

/** Pins a bare date to midday before formatting — parsed as-is it is UTC
 * midnight, which reads as the day before anywhere west of Greenwich. */
export function humanDay(value: string): string {
  const iso = /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00Z` : value;
  return new Date(iso).toLocaleDateString(undefined, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
